import { parseCurrency } from 'components/Widget/shared/currency';
import { sanitizeDecimalInput } from 'components/Widget/shared/decimalInput';
import { parsePercent } from 'components/Widget/shared/percent';
import {
  EXTRA_PAYMENT_ERROR,
  LOAN_AMOUNT_ERROR,
  MAX_FIELD_VALUE,
  MAX_LOAN_AMOUNT,
  MAX_RATE,
  RATE_ERROR,
  TERM_BOUNDS,
  TERM_ERROR,
} from './constants';
import type { LoanFormErrors, LoanValidationInput } from './types';

/**
 * Tested on the sanitized string rather than the parsed number: `parse*` maps both `''` and `abc` to
 * 0, so a field that holds nothing a digit can be read from would otherwise pass a zero-floor check.
 */
const isBlank = (raw: string): boolean => sanitizeDecimalInput(raw).replace('.', '') === '';

const isOutsideRange = (raw: string, minimum: number, maximum: number, parse = parseCurrency): boolean => {
  if (isBlank(raw)) return true;

  const value = parse(raw);

  return value < minimum || value > maximum;
};

/** A toggled-off extra payment keeps whatever was last typed, so validating it would block Calculate invisibly. */
export const validateLoanForm = (state: LoanValidationInput): LoanFormErrors => {
  const errors: LoanFormErrors = {};
  const term = TERM_BOUNDS[state.termUnit];

  if (isOutsideRange(state.loanAmount, 1, MAX_LOAN_AMOUNT)) errors.loanAmount = LOAN_AMOUNT_ERROR;

  if (isOutsideRange(state.rate, 0, MAX_RATE, parsePercent)) errors.rate = RATE_ERROR;

  if (isOutsideRange(state.term, term.minimum, term.maximum)) errors.term = TERM_ERROR(state.termUnit);

  if (state.isExtraPaymentOn && isOutsideRange(state.extraPayment, 1, MAX_FIELD_VALUE)) {
    errors.extraPayment = EXTRA_PAYMENT_ERROR;
  }

  return errors;
};
